import styled, { css } from 'styled-components';
import { BORDER_RADIUS, COLOURS, media, mediaMap, SHADOWS } from '@belong/themes';
import { Button } from '../../actions/Button';
import withLink from '../../hocs/withLink';
import Picture from '../../styles/Picture';
import { UICard } from '../../styles/UICard';

const BORDER_PADDING = {
  xs: {
    h: '1.6rem',
    v: '1.6rem',
    imageSide: 'bottom'
  },
  md: {
    h: '3.2rem',
    v: '2.4rem',
    imageSide: 'right'
  }
};

export const Root = styled(UICard)<{ showHoverEffect?: boolean }>`
  position: relative;
  background: ${COLOURS.BLACK};
  overflow: hidden;
  text-decoration: none;
  box-shadow: ${SHADOWS.KEY_LIGHT};
  transition:
    box-shadow 0.3s ease-in,
    border 0.3s ease-in;

  ${(props): any =>
    props.showHoverEffect &&
    `
      cursor: pointer;
      &:hover { 
        box-shadow: ${SHADOWS.HOVER};
      }
  `}

  ${mediaMap(
    BORDER_PADDING,
    ({ v, h }) => css`
      padding: ${v} ${h};
    `
  )};
`;
Root.displayName = 'Root';

export const Image = styled(Picture)`
  width: 100%;
  height: auto;
  transition: transform 0.3s ease-out;
  will-change: transform;

  ${media('md')`
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: left center;
  `}

  &:hover,
  ${Root}:hover & {
    ${(props): any =>
      props.showHoverEffect &&
      `
      transform: scale(1.05); // same as ArticleTile.styles:hover //TODO: constantify it
    `}
  }
`;
Image.displayName = 'Image';

export const ImageWrapper = styled.div`
  line-height: 1;
  position: relative;

  ${mediaMap(BORDER_PADDING, ({ h, v, imageSide }) => {
    if (imageSide === 'bottom') {
      return css`
        margin: ${v} -${h} -${v};

        border-bottom-left-radius: ${BORDER_RADIUS.CARD};
        border-bottom-right-radius: ${BORDER_RADIUS.CARD};
      `;
    }

    return css`
      height: calc(100% + (${v} * 2));
      width: 100%;
      margin: 0;
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
      position: absolute;
      left: 0;
      right: 0;
      top: -${v};
      bottom: 0;
      transform: translateX(${h});
    `;
  })};
`;
ImageWrapper.displayName = 'ImageWrapper';

export const ImageArea = styled.div<{ hideImageOnSmallDevices?: boolean }>`
  position: relative;
  height: 100%;

  ${(props): any => props.hideImageOnSmallDevices && `display: none;`}

  ${media('md')`display: block;`};
`;
ImageArea.displayName = 'ImageArea';

export const CalloutWrapper = styled.div`
  margin-bottom: 0.8rem;
  ${media('md')`
    margin-bottom: 1.6rem;
  `}
`;
CalloutWrapper.displayName = 'CalloutWrapper';

export const LinkOverlay = withLink(styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  content: ' ';
  z-index: 2;
`);
LinkOverlay.displayName = 'LinkOverlay';

export const DisclaimerWrapper = styled.div`
  z-index: 3;
  position: relative;
`;

export const StyledButton = styled(Button)`
  z-index: 3;
`;
